@if (isLoaded || isOnboarding) {
<div
  class="dashboard-card"
  [class.onboarding]="isOnboarding"
  [routerLink]="isFeatureSelection ? null : '/cms/live-events'"
>
  @if (isOnboarding || !items?.length) {
  <div class="card-contents">
    <mat-card appearance="outlined" class="Kurse-card">
      <div class="entity-info">
        <div class="entity-info__container">
          <div class="entity-title">
            <div class="title">
              <mat-icon>live_tv</mat-icon>
              {{ 'dashboardNew.liveEventCardDefault.title' | translate }}
            </div>
            <ng-content select="[featureLinkButton]">
              <qa-button
                [isRaisedButton]="true"
                [isIconButton]="true"
                [isRoundedButton]="true"
                (submitted)="openAddContentDialog($event)"
                icon="add"
              ></qa-button>
            </ng-content>
          </div>
          <div class="description">
            {{ 'dashboardNew.liveEventCardDefault.description' | translate }}
          </div>
        </div>
      </div>
      <div class="entity-list">
        <p class="details-title">
          {{ 'dashboardNew.courseCardDefault.detailsTitle' | translate }}
        </p>
        <div class="feature-list">
          <ng-content select="[onboardingFeatures]">
            <ul>
              <li>
                {{ 'dashboardNew.liveEventCardDefault.liveQuiz' | translate }}
              </li>
              <li>
                {{ 'dashboardNew.liveEventCardDefault.liveSurvey' | translate }}
              </li>
              <li>
                {{ 'dashboardNew.liveEventCardDefault.wordClouds' | translate }}
              </li>
              <li>
                {{
                  'dashboardNew.liveEventCardDefault.designingIntroductionsConclusions'
                    | translate
                }}
              </li>
            </ul>
          </ng-content>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="bottomSection"></ng-container>
    </mat-card>
  </div>
  } @else {
  <div class="card-contents">
    <mat-card appearance="outlined" class="Kurse-card">
      <div class="entity-info">
        <div class="entity-info__container">
          <div class="entity-title">
            <div class="title">
              <mat-icon>live_tv</mat-icon>
              {{ 'dashboardNew.liveEventCard.title' | translate }}
            </div>
            <qa-button
              [isRaisedButton]="true"
              [isIconButton]="true"
              [isRoundedButton]="true"
              (submitted)="openAddContentDialog($event)"
              icon="add"
            ></qa-button>
          </div>
          <div class="description">
            {{ 'dashboardNew.liveEventCard.description' | translate }}
          </div>
        </div>
      </div>
      <div class="entity-list">
        @for (event of items; track event.id) {
        <div class="entity-item" routerLink="/cms/live-events/{{ event.id }}">
          <div class="entity-name">{{ event.name }}</div>
          <div class="entity-edit">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </div>
        </div>
        }
        <div
          class="entity-item-show-all-btn"
          data-cy="showAllEvents"
          [class.hidden]="totalItems <= listLength"
          routerLink="/cms/live-events"
        >
          {{ 'dashboardNew.liveEventCard.showAll' | translate }}
          <mat-icon>chevron_right</mat-icon>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="bottomSection"></ng-container>
    </mat-card>
  </div>
  }
</div>
}

<ng-template #bottomSection>
  <div class="bottom-section">
    @if(cardPreferences.showTutorial){
    <div class="entity-item-show-all">
      <div class="tutorial-wrapper">
        <qa-button
          icon="videocam"
          label="dashboardNew.courseCardDefault.courseVideo"
          (submitted)="openVideo($event)"
        ></qa-button>
        <qa-button
          icon="school"
          label="dashboardNew.courseCard.academicButton"
          (submitted)="openStep($event)"
        ></qa-button>
        <qa-button
          icon=""
          (submitted)="onGuidedTour($event)"
          label="dashboardNew.courseCard.guidedTourButton"
        ></qa-button>
      </div>
      <mat-icon class="close-icon" (click)="onShowTutorial($event)">
        close
      </mat-icon>
    </div>
    } @else {
    <div class="onboarding-wrapper">
      <div class="onboarding-content" (click)="onShowTutorial($event)">
        <mat-icon>refresh</mat-icon>
        <span>{{
          'dashboardNew.progressSection.showTutorial' | translate
        }}</span>
      </div>
    </div>
    } @if(cardPreferences.showOnboarding){
    <div class="progress-container" (click)="onProgressClick($event)">
      <qa-progress-status-bar
        [progressBarData]="progress"
        [showCloseIcon]="true"
        (closeClick)="onShowOnboarding($event)"
      ></qa-progress-status-bar>
    </div>
    } @else {
    <div class="onboarding-wrapper">
      <div
        class="onboarding-content"
        [matTooltip]="
          'dashboardNew.progressSection.showOnboardingTooltip' | translate
        "
        (click)="onShowOnboarding($event)"
      >
        <mat-icon>refresh</mat-icon>
        <span>{{
          'dashboardNew.progressSection.showOnboarding' | translate
        }}</span>
      </div>
    </div>
    }
  </div>
</ng-template>
